import { useState } from 'react';
import { ResearchList } from '../types/research';

interface ResearchReportCardProps {
  reportList: ResearchList;
}

export default function ResearchReportCard({ reportList }: ResearchReportCardProps) {
  const [showAllReports, setShowAllReports] = useState(false);

  const toggleShowAll = () => {
    setShowAllReports(!showAllReports);
  };

  const displayedReports = showAllReports ? reportList : reportList.slice(0, 3);

  return (
    <div className="research-report mt-6 px-4 sm:px-12 md:px-12">
      <div className="border border-gray-200 rounded-lg">
        <div className="border-b border-gray-200 p-2 sm:p-4 md:p-4 ">
          <h2 className="text-sm sm:text-lg md:text-xl lg:text-2xl font-semibold">Research Reports</h2>
        </div>
        <div className="p-4">
          <div className="space-y-2">
            {displayedReports.map((item) => (
              <div key={item.id} className="flex items-center p-2">
                <svg
                  className="w-5 h-5 mr-2.5 text-gray-500"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M773.82 338.84L625.06 194.28v144.56z m-220.1 69.33V165.51H268.47q-15 0-25.34 10.06a33 33 0 0 0-10.31 24.61v624a32.84 32.84 0 0 0 10.31 24.61q10.29 10.05 25.34 10.05h499.2q15.08 0 25.37-10.05a33 33 0 0 0 10.27-24.61v-416z m-285.23-312h356.57l249.58 242.67v485.33c0 28.65-10.45 53.27-31.33 73.49s-46.09 30.5-75.65 30.5H268.47q-44.25 0-75.62-30.5c-20.9-20.22-31.34-44.84-31.34-73.49v-624q0-43 31.34-73.49t75.62-30.51z m0 0"
                    fill="currentColor"
                  />
                </svg>
                <div className="flex-1">
                  <a
                    href={item.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-sm leading-5 text-white hover:text-[#56b4e8] transition-colors"
                  >
                    {item.title}
                  </a>
                </div>
              </div>
            ))}
          </div>
          {reportList.length > 3 && (
            <div className="mt-2.5 text-center">
              <button
                onClick={toggleShowAll}
                className="text-sm text-white hover:text-[#56b4e8] transition-colors"
              >
                {showAllReports
                  ? 'Collapse'
                  : `View all (${reportList.length})`}
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
